module.exports = __webpack_public_path__ + "img/chaipos.ce921de3.jpg";